import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import WhyFatima from "@/components/site/WhyFatima";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="bg-plum text-cream min-h-screen font-sans overflow-hidden"
    >
      <Nav />
      <Hero />
      <About />
      <Services />
      <Marquee />
      <Manifesto />
      <WhyFatima />
      <FinalCTA />
      <Footer />
    </main>
  );
}
